import { ReferenceDataOptionLists } from '../../../lib/constants/reference-data-option-lists';
import { Deserializable } from '../../../lib/models/deserializable';

export class ApplicantEmploymentAccountantType implements Deserializable {
  public ApplicantEmploymentAccountantTypeID: number;
  public EmploymentNumber?: number;
  public AccountantTypeCode: string;
  public AccountantTypeDetails: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
